<template>
  <div class="waveform">
    <button type="button" class="btn-toggle" @click="handlePlayPause">
      <PlayingIcon
        v-if="isPlaying && !isLoading"
        :inner-color="iconInnerColor"
        :outer-color="iconOuterColor"
      />
      <PlayIcon
        v-else
        :inner-color="isLoading ? 'gray' : iconInnerColor"
        :outer-color="isLoading ? '#cacaca' : iconOuterColor"
        :class="{ spinning: isLoading }"
      />
    </button>
    <div ref="waveform"></div>
  </div>
</template>

<script>
import WaveSurfer from 'wavesurfer.js';
import PlayIcon from './icons/PlayIcon.vue';
import PlayingIcon from './icons/PlayingIcon.vue';

export default {
  components: {
    PlayIcon,
    PlayingIcon,
  },
  props: {
    url: {
      type: String,
      required: true,
    },
    iconInnerColor: {
      type: String,
      default: '#ffffff',
      required: false,
    },
    iconOuterColor: {
      type: String,
      default: '#000000',
      required: false,
    },
  },
  data() {
    return {
      waveSurfer: null,
      isPlaying: false,
      isLoading: false,
    };
  },
  watch: {
    url: {
      immediate: true,
      handler(newUrl) {
        if (this.waveSurfer && newUrl) {
          this.isLoading = true;
          this.waveSurfer.load(newUrl);
        }
      },
    },
  },
  mounted() {
    this.waveSurfer = WaveSurfer.create({
      container: this.$refs.waveform,
      waveColor: '#c38cb9',
      progressColor: '#8d5185',
      height: 30,
      width: 200,
      cursorWidth: 0,
      normalize: true,
      dragToSeek: true,
      barWidth: 2,
      barGap: 1,
    });

    this.waveSurfer.on('loading', () => {
      this.isLoading = true;
    });

    this.waveSurfer.on('ready', () => {
      this.isLoading = false;
    });

    if (this.url) {
      this.waveSurfer.load(this.url);
    }
  },
  beforeDestroy() {
    if (this.waveSurfer) {
      this.waveSurfer.destroy();
    }
  },
  methods: {
    handlePlayPause() {
      this.waveSurfer.playPause();
      this.waveSurfer.on('pause', () => {
        this.isPlaying = false;
      });
      this.waveSurfer.on('play', () => {
        this.isPlaying = true;
      });
    },
  },
};
</script>

<style scoped>
.waveform,
.waveform > div {
  width: 100%;
}

.waveform {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  gap: 1rem;
}

button {
  background: transparent;
  border: none;
  margin-left: 0.25rem;
}

.playing-btn {
  width: 28px !important;
  height: 28px !important;
  padding-left: 0 !important;
}

.spinning {
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.btn-toggle {
  margin-left: 0;
  padding: 0;
}

.loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 1.5rem;
  color: #ffffff;
  cursor: wait;
}
</style>
